export default function SvgFilters() {
  return (
    <svg className="svg-filters" aria-hidden="true">
      <filter
        id="lumina-glass"
        x="-50%"
        y="-50%"
        width="200%"
        height="200%"
      >
        <feGaussianBlur stdDeviation="6" in="SourceGraphic" result="blur" />
        <feColorMatrix
          in="blur"
          type="matrix"
          values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
          result="goo"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.015"
          numOctaves="3"
          result="noise"
        />
        <feDisplacementMap
          in="goo"
          in2="noise"
          scale="15"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
    </svg>
  );
}
